import Keycloak, {KeycloakConfig} from 'keycloak-js';

const initializeKeycloak = (config?: KeycloakConfig | string) =>
  new Keycloak(config);

export default initializeKeycloak;
